export default __webpack_public_path__ + "static/media/uiux.a0ff8e7e.svg";